/**
 * The `server_settings` message — session state the SERVER owns.
 *
 * A different message from `parameters`: it is never stored in a preset, never tweened, and the server carries its own defaults, so a session is fully configured before any client connects.
 *
 * WHY A PROJECTION AND NOT THE SETTINGS SLICE ITSELF. `settings` is ~20 keys of local preference — theme, the `confirm_*` prompts, `show_fps` — persisted per user and meaningful only to this browser. The whole effect used to be sent to the server on every settings change (and silently dropped into `client_parameters`, where nothing read it). Sending it for real would make one user's theme toggle a broadcast to every peer in the session. Only the keys the server actually consumes cross the wire.
 *
 * Pure and store-free, so both callers can use it: the handshake reply in socket.js and the change listener in the liveSync middleware.
 */
import server_settings_schema from '~/schemas/server_settings_schema'

/**
 * The keys the server consumes, from the contract.
 *
 * Derived, not hand-listed, so adding one to the contract does not need an edit here — and so this cannot silently disagree with what the server will accept.
 */
export const SERVER_SETTING_KEYS = Object.keys(server_settings_schema.properties)

/** The subset of the settings slice that belongs on the wire. */
export function serverSettingsFrom(settings) {
	const out = {}
	for (const key of SERVER_SETTING_KEYS) {
		if (settings?.[key] !== undefined) out[key] = settings[key]
	}
	return out
}
